import { StandardDataUnit } from "@/lib/api";

enum CustomUnitRender {
  OKTA = "the_unit_of_cloud_amount_okta_is_an_eighth_of_the_sky_dome_covered_by_cloud",
}

const UnitRenderer = (value: string, unit: StandardDataUnit) => {
  switch (unit.type) {
    case CustomUnitRender.OKTA:
      return `${value}/8`;
    default:
      return `${value}${unit.symbol}`;
  }
};

export default UnitRenderer;
